import {
  createMessage as createMessageRequest,
  getMessage as getMessageRequest,
  listMessages as listMessagesRequest,
  updateMessage as updateMessageRequest
} from '@cbgms/api/modules/messages/requests'
import { GETSupportMessageResponse, POSTMessageBody, POSTMessageResponse, PUTMessageBody } from '@cbgms/api/modules/messages'
import { IPaginatedRequest } from '@cbgms/api/request'

import * as types from './types'
import { AsyncAction } from '@cbgms/base/redux/async-action'

export const listMessages = (params: IPaginatedRequest) => ({
  type: [types.GET_MESSAGES, types.GET_MESSAGES_SUCCESS, types.GET_MESSAGES_FAILED],
  payload: {
    api: 'support',
    request: listMessagesRequest(params)
  }
})

export const getMessage = (messageUUID: string) =>
  AsyncAction<GETSupportMessageResponse>({
    type: [types.GET_MESSAGE, types.GET_MESSAGE_SUCCESS, types.GET_MESSAGE_FAILED],
    payload: {
      api: 'support',
      request: getMessageRequest(messageUUID)
    }
  })

export const createMessage = (data: POSTMessageBody) =>
  AsyncAction<POSTMessageResponse>({
    type: [types.CREATE_MESSAGE, types.CREATE_MESSAGE_SUCCESS, types.CREATE_MESSAGE_FAILED],
    payload: {
      api: 'support',
      request: createMessageRequest(data)
    }
  })

export const updateMessage = (messageUUID: string, data: PUTMessageBody) => ({
  type: [types.UPDATE_MESSAGE, types.UPDATE_MESSAGE_SUCCESS, types.UPDATE_MESSAGE_FAILED],
  payload: {
    api: 'support',
    request: updateMessageRequest(messageUUID, data)
  }
})
